import { freeze } from 'icepick';
import {
	VELOCITY_DATA_FETCH_SUCCESS,
	type VelocityDataFetchSuccessAction,
} from '../../../actions/velocity-data-fetch';
import type { SprintsState } from './types';

export type Action = VelocityDataFetchSuccessAction;

const defaultState: SprintsState = [];

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: SprintsState = defaultState, action: Action): SprintsState => {
	switch (action.type) {
		case VELOCITY_DATA_FETCH_SUCCESS:
			return freeze(action.payload);
		default: {
			const _exhaustiveCheck: never = action.type;
			return state;
		}
	}
};
